import React from 'react'

export default function servicios() {
    return (
        <div>
            hello from services page
        </div>
    )
}
